import { Box } from '@mentimeter/ragnar-ui/box';
import { isEmptyObject } from '@tiptap/core';
import { useTranslations } from 'next-intl';
import type { InteractiveCanvasComponents } from '@mentimeter/question-modules-types';
import { TitleSection } from '../../shared/components/title-section/TitleSection';
import { VideoDataHandler } from './components/VideoDataHandler';

interface VideoPresentationProps {
  title: string;
  styledTitle: Record<string, unknown>;
  label: string;
  textSizeOffset: -2 | -1 | 0 | 1 | 2;
  videoUrl: string;
  CanvasTitleArea: InteractiveCanvasComponents['CanvasTitleArea'];
  isReadOnly: boolean;
  isScreenshotMode: boolean;
}

export function VideoPresentation({
  title,
  styledTitle,
  label,
  textSizeOffset,
  videoUrl,
  CanvasTitleArea,
  isReadOnly,
  isScreenshotMode,
}: VideoPresentationProps) {
  const t = useTranslations('presenting');

  // When we are in Editor always show TitleSection. If we are in a presentation we only show if there is a styled/non-styled title. Otherwise hide since we don't want the container taking up empty space.
  const showTitleSection = Boolean(
    CanvasTitleArea || !isEmptyObject(styledTitle) || title,
  );

  return (
    <Box width="100%" height="100%">
      <VideoDataHandler
        videoUrl={videoUrl}
        shouldShowPreview={isScreenshotMode}
        readonly={isReadOnly}
      />
      {showTitleSection ? (
        <TitleSection
          enablePlaceholderAlignment
          hideAIEditingSuggestions
          alignItems="center"
          textAlign="center"
          title={title}
          styledTitle={styledTitle}
          label={label}
          fontSizeOffset={textSizeOffset}
          mb="space0"
          placeholder={t('video_slide_caption_placeholder')}
          showTextSizeDropdown={false}
        />
      ) : null}
    </Box>
  );
}
